import { render } from "./FormLayoutPage.vue?vue&type=template&id=5dd1e75c&ts=true"
import script from "./FormLayoutPage.vue?vue&type=script&lang=ts"
export * from "./FormLayoutPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__